import { createApp } from 'vue';
import App from './App.vue';
import Widget from './widget/index';
import AttrItem from './components/AttrItem.vue';
import Node from './components/Node.vue';
import moment from 'moment'

const app = createApp(App);
moment.locale('zh-cn')

// 将Widget中的组件注册为Vue的全局组件
app.component('ListWidget', Widget['ListWidget']);
app.component('WidgetDate', Widget['WidgetDate']);
app.component('WidgetImage', Widget['WidgetImage']);
app.component('WidgetSpacer', Widget['WidgetSpacer']);
app.component('WidgetText', Widget['WidgetText']);
app.component('WidgetStack', Widget['WidgetStack']);

app.component('AttrItem', AttrItem);
app.component('Node', Node);

app.mount('#app');
